import { useState } from "preact/hooks";
import { chooseTheme, storedTheme } from "./lib/theme.ts";
import type { ThemeChoice } from "./lib/theme.ts";

/** The remembered theme, and a setter that applies and remembers a new one. */
export function useTheme(): [ThemeChoice, (choice: ThemeChoice) => void] {
  const [theme, setTheme] = useState(storedTheme);
  return [theme, (choice) => { chooseTheme(choice); setTheme(choice); }];
}
